// Native TON coin was rebranded GRAM; the network keeps the label TON.
export function tokenLabel(sym: string): string {
  return sym.toUpperCase() === 'TON' ? 'GRAM' : sym
}
